/**
 * IOC Container implementation.
 * 
 * @since 1.0.0
 * @package dealerkit-wp
 */
export class Container
{
    constructor() {
        this.flush()
    }

    bind(abstract, constructor) {
        this.constructors[abstract] = {
            type: 'transient',
            constructor
        }
    }

    singleton(abstract, constructor) {
        this.constructors[abstract] = {
            type: 'singleton',
            constructor
        }
    }

    flush() {
        this.constructors = {}
        this.instances = {}
    }

    make(abstract, args = {}) {
        const resolved = this.constructors[abstract]
        
        if (resolved.type === 'singleton') {
            if (!this.instances[abstract]) {
                this.instances[abstract] = resolved.constructor.call(null, args)
            }

            return this.instances[abstract]
        }

        return resolved.constructor.call(null, args)
    }
}